import { jsx as _jsx } from "react/jsx-runtime";
import { TabsActionsStructureProvider } from '#pplx/frontend/aether/components/Tabs/internal/TabsStructureContext.js';
import { useIsInsideTabsHeader, useIsInsideTabsList, } from '#pplx/frontend/aether/components/Tabs/internal/useTabsStructure.js';
import { Children } from 'react';
const TABS_ACTIONS_CLASSES = 'flex shrink-0 items-center gap-1';
/** Groups Tabs.Action children alongside a tab list as a direct child of Tabs.Header. */
export function TabsActions({ children }) {
    const isInsideHeader = useIsInsideTabsHeader();
    const isInsideList = useIsInsideTabsList();
    if (!isInsideHeader || isInsideList) {
        throw new Error('Tabs.Actions must be a direct child of Tabs.Header, outside Tabs.List');
    }
    const actionChildren = Children.toArray(children);
    if (actionChildren.length === 0) {
        return null;
    }
    return (_jsx(TabsActionsStructureProvider, { children: _jsx("div", { className: TABS_ACTIONS_CLASSES, children: actionChildren }) }));
}
//# sourceMappingURL=TabsActions.js.map